import { UserModel } from 'models/user';
import { mapUserDropdownOptions } from 'helpers/dropdown-options';

export function mapUsersOptions(users: UserModel[]) {
  return mapUserDropdownOptions(users, true);
}
